/* Grunwald Journal: TOC, video facades, shelves, share, progress, recipe tools */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function slug(t) {
    return (t || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60) || 'section';
  }

  function toc() {
    var body = $('[data-j-body]');
    if (!body) return;
    var hs = $$('h2', body).filter(function (h) { return !h.closest('.j-feature') && !h.closest('.j-bookbox'); });
    if (hs.length < 4) return;
    hs.forEach(function (h) {
      if (!h.id) {
        var base = slug(h.textContent), s = base, i = 2;
        while (document.getElementById(s)) { s = base + '-' + i++; }
        h.id = s;
      }
    });
    $$('[data-j-toc]').forEach(function (nav) {
      var ol = $('ol', nav);
      hs.forEach(function (h) {
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.replace(/^Recipe/, '').trim();
        li.appendChild(a); ol.appendChild(li);
      });
      nav.hidden = false;
    });
    var links = $$('[data-j-toc] a');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id); });
          }
        });
      }, { rootMargin: '-15% 0px -75% 0px' });
      hs.forEach(function (h) { io.observe(h); });
    }
  }

  var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7 4.5v15l13-7.5z"/></svg>';

  function videos() {
    var root = $('.j-article');
    var channel = (root && root.getAttribute('data-yt-channel')) || 'https://www.youtube.com/@grunwald-publishing';
    $$('.j-video[data-yt]').forEach(function (el) {
      var id = el.getAttribute('data-yt');
      if (!/^[\w-]{6,20}$/.test(id)) return;
      var isShort = el.getAttribute('data-format') === 'short';
      var link = $('a', el);
      var title = (link ? link.textContent : '').replace(/^Watch on YouTube:\s*/i, '').trim();
      var thumb = 'https://i.ytimg.com/vi/' + id + (isShort ? '/oar2.jpg' : '/maxresdefault.jpg');
      var fallback = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
      var frame = document.createElement('button');
      frame.type = 'button';
      frame.className = 'j-video__frame';
      frame.setAttribute('aria-label', 'Play video: ' + title);
      var img = document.createElement('img');
      img.loading = 'lazy'; img.alt = ''; img.src = thumb;
      img.onerror = function () { if (img.src !== fallback) img.src = fallback; };
      frame.appendChild(img);
      frame.insertAdjacentHTML('beforeend', '<span class="j-video__play">' + PLAY + '</span>');
      frame.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
        f.title = title || 'YouTube video';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        f.allowFullscreen = true;
        frame.innerHTML = ''; frame.appendChild(f);
        frame.style.cursor = 'default';
      }, { once: true });
      el.innerHTML = '';
      el.classList.add(isShort ? 'j-video--short' : 'j-video--film');
      var sub = channel + '?sub_confirmation=1';
      if (isShort) {
        el.appendChild(frame);
        var t = document.createElement('div');
        t.className = 'j-video__text';
        t.innerHTML = '<span class="j-eyebrow">Watch · from our channel</span>' +
          '<p class="j-video__title"></p>' +
          '<p class="j-video__sub">Belarusian words, dishes and animated folk tales on the Grunwald YouTube channel.</p>' +
          '<a class="j-btn j-btn--light j-btn--sm" target="_blank" rel="noopener" href="' + sub + '">Subscribe on YouTube</a>';
        $('.j-video__title', t).textContent = title;
        el.appendChild(t);
      } else {
        el.appendChild(frame);
        var c = document.createElement('div');
        c.className = 'j-video__cap';
        c.innerHTML = '<strong></strong><a class="j-btn j-btn--ghost j-btn--sm" target="_blank" rel="noopener" href="' + sub + '">Subscribe on YouTube</a>';
        $('strong', c).textContent = title;
        el.appendChild(c);
      }
    });
  }

  function shelves() {
    $$('[data-j-shelf]').forEach(function (s) {
      var t = $('[data-j-track]', s), p = $('[data-j-prev]', s), n = $('[data-j-next]', s), nav = $('.j-shelf__nav', s);
      if (!t) return;
      var step = function () { var c = t.firstElementChild; return c ? c.getBoundingClientRect().width + 24 : 260; };
      var upd = function () {
        var over = t.scrollWidth > t.clientWidth + 4;
        if (nav) nav.hidden = !over;
        if (p) p.disabled = t.scrollLeft <= 4;
        if (n) n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
      };
      if (p) p.addEventListener('click', function () { t.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { t.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      t.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  function share() {
    $$('[data-j-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-j-copy');
        var done = function () { b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 2000); };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () {});
      });
    });
  }

  function progress() {
    var bar = $('.j-progress'), art = $('[data-j-body]');
    if (!bar || !art) return;
    var tick = false;
    var f = function () {
      var r = art.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var pct = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      bar.style.transform = 'scaleX(' + pct.toFixed(4) + ')';
      tick = false;
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(f); } }, { passive: true });
    f();
  }

  function recipes() {
    $$('.j-recipe').forEach(function (r, i) {
      if (!r.id) r.id = i ? 'recipe-' + (i + 1) : 'recipe';
      var h = $('h2', r);
      var bar = document.createElement('div');
      bar.className = 'j-recipe__actions';
      bar.innerHTML = '<button type="button">Print recipe</button>';
      $('button', bar).addEventListener('click', function () {
        document.body.classList.add('j-printing');
        window.print();
        setTimeout(function () { document.body.classList.remove('j-printing'); }, 500);
      });
      if (h && h.nextSibling) r.insertBefore(bar, h.nextSibling); else r.appendChild(bar);
    });
  }

  function init() { toc(); videos(); shelves(); share(); progress(); recipes(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
